import { Controller } from "@hotwired/stimulus"

// The "exam settings" strip above the landing's demo question (static Cloudflare
// Pages export, so everything is client-side). One switch: auto-advance — open the
// next question as soon as an answer is tapped, instead of confirming with Next.
//
// The demo answers are plain links into /guest_exam on learn.*; the choice travels
// as ?auto_advance=always|never on those links, is stored on the Guest there, and
// becomes the account's test_auto_advance at registration. The param is only added
// once the visitor has touched the switch, so an untouched switch changes nothing.
// The choice is remembered in localStorage so tabs, reloads and the locale pages agree.
const STORAGE_KEY = "guestAutoAdvance"
const LINKS = 'a[data-demo-question-target="answer"]'

export default class extends Controller {
  static targets = ["switch"]

  connect() {
    this.apply(this.stored())
  }

  toggle() {
    const next = this.switchTarget.getAttribute("aria-checked") === "true" ? "never" : "always"
    try { window.localStorage.setItem(STORAGE_KEY, next) } catch (_e) { /* private mode: the link still carries it */ }
    this.apply(next)
  }

  // choice: "always" | "never" | null (never touched)
  apply(choice) {
    this.switchTarget.setAttribute("aria-checked", String(choice === "always"))

    document.querySelectorAll(LINKS).forEach((link) => {
      const url = new URL(link.href)
      if (choice) url.searchParams.set("auto_advance", choice)
      else url.searchParams.delete("auto_advance")
      link.href = url.toString()
    })
  }

  stored() {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY)
      return value === "always" || value === "never" ? value : null
    } catch (_e) {
      return null
    }
  }
}
